// Permette ai moduli fuori da React (es. interceptor axios) di mostrare toast.
// Se il ToastProvider non è montato il messaggio viene scartato.

type ToastType = 'success' | 'error' | 'info';
type ToastHandler = (message: string, type?: ToastType) => void;

let handler: ToastHandler | null = null;

export function registerToastHandler(fn: ToastHandler): void {
    handler = fn;
}

export function unregisterToastHandler(): void {
    handler = null;
}

export function notifyToast(message: string, type: ToastType = 'info'): void {
    if (handler) {
        handler(message, type);
    }
}
